import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';

export const ViewRentsWork = ({ rents }) => {

    if (typeof rents === 'string') rents = JSON.parse(rents)
    return (
        <TableContainer component='div' >
            <Table sx={{ minWidth: 650 }} size='small' aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell align='center'><b>Concepto</b></TableCell>
                        <TableCell align="center"><b>Unidad</b></TableCell>
                        <TableCell align="center"><b>Cantidad</b></TableCell>
                        <TableCell align='center'><b>Precio/día x ud</b></TableCell>
                        <TableCell align='center'><b>Días de alquiler</b></TableCell>
 
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rents.map(fields => (
                        <TableRow key={fields.id}>
                            <TableCell align='center'>{fields.concept}</TableCell>
                            <TableCell align="center">{fields.measure}</TableCell>
                            <TableCell align="center">{fields.size}</TableCell>
                            <TableCell align='center'>{fields.price}</TableCell>
                            <TableCell align='center'>{fields.rentsDays}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
        )
    }
    
    // <Fragment>
    //     {rents.map(s => (
    //         <Stack width='100%' key={s.id} direction='row' justifyContent='space-between'>
    //             <Typography variant='subtitle1'><b>Concepto: </b> {s.concept}</Typography>
    //             <Typography variant='subtitle1'><b>Unidad: </b> {s.measure}</Typography>
    //             <Typography variant='subtitle1'><b>Cantidad: </b> {s.size}</Typography>
    //             <Typography variant='subtitle1'><b>Precio/unidad: </b> {s.price}€</Typography>
    //         </Stack>
    //     ))}
    // </Fragment>